<template>
  <div class="table-wrapper">
    <div class="row">
      <div class="col-md-6 col-sm-12 grid-search-control">
        <SearchField
          v-model:textSearch="textSearch"
          placeholder="Search for finding types by name and component type"
          @input="isSpinnerVisible = true"
          @search="search"
        />
      </div>
    </div>

    <div
      class="table-responsive"
      v-bind:class="{ 'spinner-is-visible': isSpinnerVisible }"
    >
      <table class="table">
        <thead>
          <tr>
            <SortableHeader
              style="width: 300px"
              :current-sort="orderBy"
              :sort-by="'NAME'"
              @sort="reorder"
            >Finding Type</SortableHeader>

            <th>Details</th>

            <SortableHeader
              style="width: 200px"
              :current-sort="orderBy"
              :sort-by="'COMPONENT_TYPE_NAME'"
              @sort="reorder"
            >Component Type</SortableHeader>

            <th data-sorter="false" class="d-none d-md-table-cell"></th>
          </tr>
        </thead>

        <tbody>
          <FindingType
            v-for="(item, index) in items"
            v-bind="item"
            :key="item.id"
            :index="index"
            :policy-update="policyUpdate"
            :ref="item.id"
            :selected="isItemMarked(item.id)"
          />
        </tbody>
      </table>

      <div class="spinner"></div>

      <NoRecords 
        label="According to the search criteria, there are no finding types found."
      />

      <Pagination
        v-bind="pageInfo"
        entity-type="finding types"
        @navigate-to="paginate"
      />
    </div>
  </div>
</template>

<script>
import Grid from "../shared/grid/grid";

import FindingType from "./finding_type";

export default {
  extends: Grid,

  components: {
    FindingType
  },

  data: function () {
    return {
      items: [],

      grid: "finding-types",

      textSearch: '',

      defaultOrderBy: {
        field: "NAME",
        direction: "ASC"
      },
      
      orderBy: {
        field: "NAME",
        direction: "ASC"
      },

      pageInfo: {
        pageSize: 20,
        currentPage: 1,
        totalCount: 0,
        totalPageCount: 0
      },

      isSpinnerVisible: true
    }
  },

  computed: {
    filterParams: function () {
      if (this.textSearch) {
        return {
          text: {
            value: this.textSearch,
            fields: this.textSearchFields
          }
        };
      }
    },

    textSearchFields: function () {
      return ["NAME", "COMPONENT_TYPE_NAME"];
    }
  },

  methods: {
    fetch: function (params, success) {
      app.graphql.get("grid.findingTypes",
        params,

        (data) => {
          let finding_types = data.data.findingTypes,
              pageInfo = finding_types.pageInfo;

          success(finding_types, pageInfo);
        },

        (error) => {
          app.ui.toast.add({
            priority: "danger",
            title: "Something went wrong!",
            message: "Unable to fetch finding types!"
          })
        }
      )
    }
  }
}
</script>
